<template>
  <div class="gray-back" style="padding:.2rem 0 1rem 0 ">
    <van-cell-group>
      <van-cell title="省市" :value="row.county?row.province+'/'+row.city+'/'+row.county:''"/>
      <van-cell title="学校" :value="row.danwei"/>
      <van-cell title="参赛人数" :value="row.renshu"/>
      <van-cell title="联系人姓名" :value="row.name"/>
      <van-cell title="联系人手机" :value="row.phone"/>
      <van-cell title="联系人邮箱" :value="row.email"/>
    </van-cell-group>
    <van-divider>校长信息</van-divider>
    <van-cell-group>
      <van-cell title="校长姓名" :value="row.xiaozhang_name"/>
      <van-cell title="校长身份证号" :value="row.xiaozhang_num"/>
    </van-cell-group>
    <van-divider>教师信息(先进个人)</van-divider>
    <van-cell-group>
      <van-cell title="教师姓名" :value="row.jiaoshi_name"/>
      <van-cell title="教师身份证" :value="row.jiaoshi_num"/>
    </van-cell-group>
    <van-divider>审核信息</van-divider>
    <van-cell title="备案审核">
      <div v-if="row.registstatus==0">未提交</div>
      <div v-else-if="row.registstatus==1">待审核</div>
      <div v-else-if="row.registstatus==2">审核通过</div>
      <div v-else-if="row.registstatus==3">审核失败</div>
    </van-cell>
    <van-cell title="管理员备注" :value="row.adminnote"/>
  </div>
</template>

<style scoped="">
</style>
<script>
import {
  Cell, CellGroup, Field, RadioGroup, Radio, DatetimePicker, Picker, NoticeBar, Button, Dialog, Uploader
} from 'vant';

export default {
  name: 'WyhDakejianDetail',
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker,
    [Picker.name]: Picker,
    [NoticeBar.name]: NoticeBar,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Uploader.name]: Uploader,
  },
  data: function () {
    return {
      row: {
        changdipic:[],
        shenbaozip:[],
        yanshou_pic:[],
        yanshoubiao_pic:[],
      },
      formData: {
        'id': this.$route.query.id,
      },
      showTime: false,
      timeField: '',
      showStation: false,
      stationField: '',
      loadding: false,
    }
  },
  mounted: function () {
    let that = this;
    document.title = "大课间详情";
    this.$api.get('/wyhadminapi/dakejian/dakejianDetail', {
      'id': that.$route.query.id
    }, r => {
      this.row = r.data;
      console.log(this.row)
    });

  },

  methods: {
    save: function () {
      let that = this;
      Dialog.confirm({
        title: '确认',
        message: '您确定信息准确无误吗?提交后不得修改!'
      }).then(() => {
        // on confirm
        that.$api.post('/api/sai/confirmzhixuceaction', this.formData, r => {
          that.$router.push({'name': 'saiConfirm', 'query': {'id': that.row.id}});
        }, r => {
          that.$toast.fail(r.msg);
        });
      }).catch(() => {
        // on cancel
      });


    },
    edit: function () {
      let that = this;
      this.$router.push({
        'name': 'saiConfirmQr1',
        'query': {'id': that.row.id}
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// DakejianDetail.vue?0dede1bc